import axios from "axios"
export const getClient = (user) => {
    axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`
    return axios
}